export default function () {
  const $cards = $('.link.card');

  $cards.click((event) => {
    window.location = $(event.currentTarget).data('url');
  });
}
